// TitleComponent.jsx
import React from 'react';
import { Box, Typography } from '@mui/material';
import Icon from '@mdi/react';

const TitleComponent = ({
	title,
	icon,
	iconComponent,
	color = 'var(--primary-main)',
	fontSize = null,
	fontWeight = 600,
	iconSize = "18px",
	iconColor,
	iconRotate = 0,
	iconHorizontal = false,
	iconVertical = false,
	variant = 'h6',
	sx = {},
}) => {
	return (
		<Box
			sx={{
				padding: '4px 12px',
				display: 'flex',
				alignItems: 'center',
				position: 'relative',
				paddingLeft: 0,
				...sx,
			}}
		>
			{icon && (
				<Icon
					path={icon}
					size={iconSize}
					color={iconColor || color}
					rotate={iconRotate}
					horizontal={iconHorizontal}
					vertical={iconVertical}
					style={{ marginRight: '8px' }}
				/>
			)}
			{iconComponent && iconComponent}
			<Typography
				variant={variant}
				sx={{
					fontWeight,
					color,
					fontSize: fontSize ? fontSize : { xs: '13px !important', lg: "14px !important", xl: "16px !important" },
					m: 0,
					lineHeight: 1.2,
				}}
			>
				{title}
			</Typography>
		</Box>
	);
};

export default TitleComponent;